import { SelectInput, Typography } from "@dealer-center/core-components";
import type {
  LocalStorageItem,
  UseLocalStorageKeysKeys
} from "@dealer-center/core-interfaces-components";
import {
  getItemFromLocalStorageStr,
  getLocalStorageItem,
  getLocalStorageItemActualKey,
  getLocalStorageItemDescription,
  useLocalStorageKeys
} from "@dealer-center/core-interfaces-components";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { LocalStorageButtons } from "./LocalStorageButtons";
const StyledPre = styled.pre`
  white-space: pre-wrap;
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
`;
const StyledResultsArea = styled.div`
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export function LocalStoragePage() {
  useEffect(() => {
    document.title = "Local Storage Import / Export";
  }, []);
  const LocalStorageItems: LocalStorageItem[] = [];
  const [selectedKey, setSelectedKey] = useState<
    UseLocalStorageKeysKeys | undefined
  >(undefined);

  // Iterate through the keys instead of values
  for (const key of Object.keys(
    useLocalStorageKeys
  ) as UseLocalStorageKeysKeys[]) {
    LocalStorageItems.push(getLocalStorageItem(key));
  }

  const getValueToDisplay = (selectedKey?: UseLocalStorageKeysKeys) => {
    if (!selectedKey) {
      return "";
    }
    const value = getItemFromLocalStorageStr(selectedKey);
    try {
      return value ? JSON.stringify(JSON.parse(value), null, 2) : "null";
    } catch {
      return value || "null";
    }
  };

  const valueToDisplay = getValueToDisplay(selectedKey);

  return (
    <>
      <SelectInput
        label="Select local storage item to view:"
        name="local-storage-item"
        options={LocalStorageItems.sort((a, b) =>
          a.friendlyKey.localeCompare(b.friendlyKey)
        ).map(item => ({
          value: item.actualKey,
          label: item.friendlyKey
        }))}
        value={selectedKey}
        onChange={e =>
          setSelectedKey(e.target.value as UseLocalStorageKeysKeys)
        }
      />
      {selectedKey && (
        <StyledResultsArea>
          <div>
            <Typography variant={"label-md"}>Description:</Typography>
            <Typography variant={"body-md"}>
              {getLocalStorageItemDescription(selectedKey)}
            </Typography>
          </div>
          <div>
            <Typography variant={"label-md"}>Actual Key:</Typography>
            <Typography variant={"body-md"}>
              {getLocalStorageItemActualKey(selectedKey)}
            </Typography>
          </div>
          <StyledPre>{valueToDisplay}</StyledPre>
        </StyledResultsArea>
      )}
      <LocalStorageButtons />
    </>
  );
}
